import { render } from "./Version.vue?vue&type=template&id=afa8dcd8&scoped=true"
import script from "./Version.vue?vue&type=script&lang=js"
export * from "./Version.vue?vue&type=script&lang=js"

import "./Version.vue?vue&type=style&index=0&id=afa8dcd8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afa8dcd8"]])

export default __exports__